// import { PageHeader } from "@ant-design/pro-layout";
import { PageHeader } from "../../../shared/page-header";
import { OnboardingSubPageLayout } from "../onboarding-sub-page-layout";
import {ContactDetailsContainer} from "../components/contact-details.container";
import { Helmet } from "react-helmet";
import { getItem } from "../../../shared/local-storage";

export const OnboardingContactDetails: React.FC = () => {
  const applicantUserId = getItem("applicantUserId");

  return (
    <OnboardingSubPageLayout
      header={
        <PageHeader
          title="Credential Verification for Health Professionals"
          subTitle="Profile Creation"
          description="If you are unable to provide all information and documentation in one session, or if you leave the application for any reason, the information and documentation you provided will be saved for approximately 24 hours. After that time, it will no longer be available and you will be required to begin a new request."
        />
      }
    >
      <Helmet>
        <title>Contact Details</title>
      </Helmet>
      <ContactDetailsContainer data={{ applicantUserId }} />
    </OnboardingSubPageLayout>
  );
};
